module.exports = __webpack_public_path__ + "static/media/icon-hiring-full-white.ad5553eb.svg";